import React, { useState } from "react";
import {
  Box,
  Text,
  VStack,
  HStack,
  Flex,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverBody,
  Portal,
} from "@chakra-ui/react";
import { TbShoppingBagX } from "react-icons/tb";
// import PropTypes from "prop-types";

const CustomizationTooltip = ({
  modifierGroupText,
  customizationName,
  options,
  sold_out,
  placement = "top",
  customization,
   onCustomizationClick,
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  return (
    <Popover
      isOpen={isOpen}
      onOpen={handleOpen}
      onClose={handleClose}
      placement={placement}
      trigger="hover"
    >
      <PopoverTrigger>
        <Box onClick={handleOpen}>
          {children}
        </Box>
      </PopoverTrigger>
      <Portal>
        {/* Ensures the popover content is rendered above other UI elements */}
        <PopoverContent
          zIndex={9999}
          bg="gray.100"
          color="black"
          fontSize="sm"
          p={3}
          borderRadius="md"
        >
          <PopoverArrow />
          <PopoverBody>
            {/* Modifier Group Text */}
            <Text fontWeight="bold" mb={1}>
              {modifierGroupText}
            </Text>

            {/* Customization Name */}
            <HStack width="100%" justifyContent="space-between">
              <Text mb={2}>{customizationName}</Text>
              {sold_out && <TbShoppingBagX color="red" size={16} />}
            </HStack>

            {/* Options List */}
            {options && options.length > 0 ? (
              <VStack align="start" spacing={0}>
                {options.map((option, index) => (
                  <Flex key={option.id || index} fontSize="sm"
                     justify="space-between"
                     cursor={"pointer"}
                     _hover={{fontWeight:"bold"}}
                     onClick={() => {
                      onCustomizationClick(customization.id, customization)
                    }}
                     >
                    <Text>{option.option}</Text>:
                    <HStack paddingLeft={1}>
                      <Text>${Number(option.price).toFixed(2)}</Text>
                      {option.sold_out && <TbShoppingBagX color="red" size={16} />}
                    </HStack>
                  </Flex>
                ))}
              </VStack>
            ) : (
              <Text fontSize="sm" color="gray.500">
                No options available
              </Text>
            )}
          </PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  );
};


export default CustomizationTooltip;
